'use client';

import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center">
      <h1 className="font-bold text-4xl">404</h1>
      <p className="text-muted-foreground">Page not found</p>
      <Button asChild className="mt-4">
        <Link href="/">Go back home</Link>
      </Button>
    </div>
  );
}
